import React from 'react';

const ButtonLoader = () => {
  return (
    <span
      className='spinner-border spinner-border-sm mx-1'
      role='status'
      aria-hidden='true'
    ></span>
  );
};

export default ButtonLoader;
